export default __webpack_public_path__ + "static/media/BitcoinMoney.e0038703.jpeg";